export const ADMIN_GET_PAYOUTS_REQUEST = "ADMIN_GET_PAYOUTS_REQUEST";
export const ADMIN_GET_PAYOUTS_SUCCESS = "ADMIN_GET_PAYOUTS_SUCCESS";
export const ADMIN_GET_PAYOUTS_FAILURE = "ADMIN_GET_PAYOUTS_FAILURE";

export const ADMIN_PROCESS_PAYOUT_REQUEST = "ADMIN_PROCESS_PAYOUT_REQUEST";
export const ADMIN_PROCESS_PAYOUT_SUCCESS = "ADMIN_PROCESS_PAYOUT_SUCCESS";
export const ADMIN_PROCESS_PAYOUT_FAILURE = "ADMIN_PROCESS_PAYOUT_FAILURE";
